import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.number.isRequired,
  filterField: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  metric: PropTypes.bool,
  isNew: PropTypes.bool
}).isRequired;
